<template>
  <v-col cols="auto">
    <v-badge
      overlap
      :content="badgeValue"
      :value="badgeValue && badgeValue != '0'"
      color="error"
      bordered
      :offset-y="15"
      :offset-x="15"
      :style="`z-index: ${$attrs.zIndex}`"
    >
      <base-button type="alternative" :icon="icon" :tooltip="$i18n.t(`button.${name}`)" @click="openPanel()" />
    </v-badge>
  </v-col>
</template>

<script>
export default {
  name: 'TheNavbarTopPanelInfoButton',
  props: {
    name: {
      type: String,
      required: true,
    },
    badgeValue: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    additionalTableFilterValues: {
      type: Object,
      required: true,
    },
    otherTableRoutes: {
      type: Array,
      required: true,
    },
    isToolWorking: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    openPanel() {
      if (!this.isToolWorking) {
        this.pushError(this.$i18n.t('snackbar.toolNotActive'));
        return;
      }
      if (this.otherTableRoutes.includes(this.$route.name)) {
        this.$root.$emit('setAdditionalTableFilterValues', this.additionalTableFilterValues);
      } else if (this.$route.name !== this.name) {
        this.$router.push({
          name: this.name,
          params: { additionalTableFilterValues: this.additionalTableFilterValues },
        });
      } else {
        this.$root.$emit('setAdditionalTableFilterValues', this.additionalTableFilterValues);
      }
    },
    pushError(message) {
      this.$store.set('snackbar/PUSH_MESSAGE!', {
        message,
        color: '#333333',
        buttonType: 'text',
      });
    },
  },
};
</script>
